import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aef3c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-title" }

import { computed, ref, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { get } from "lodash-es";
import VuePermissie from "../components/Permissie.vue";
import NietBenaderen from "../components/NietBenaderen.vue";
import {
  CommunicatieMedium,
  communicatieMedia,
  OptInKeuze,
  GroepViewModel,
  PermissieViewModel,
} from "../TypeScriptModels";
type CheckboxStatus = {
  isAllJa: boolean;
  isAllNee: boolean;
  isAllUnknown: boolean;
  isIndeterminate: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Groep',
  props: {
  label: {
    type: String,
    default: "",
  },
  groep: {
    type: Object as PropType<GroepViewModel>,
    required: true,
  },
  nietBenaderen: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ["groepchange", "nietBenaderenChange"],
  setup(__props, { emit }: { emit: ({
  (
      e: "groepchange",
      data: {
        permissie: string;
        field: CommunicatieMedium;
        waarde: OptInKeuze;
      }
  ): void;
  (e: "nietBenaderenChange", newValue: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { t } = useI18n();





const listPermissie = ref<string[]>([
  "Auto",
  "MerkModel",
  "Bedrijf",
  "Overig",
  "Enquetes",
]);

const media = communicatieMedia;

const calculateStatus = (values: OptInKeuze[]): CheckboxStatus => {
  const ja = values.filter((keuze) => keuze === OptInKeuze.Ja);
  const nee = values.filter((keuze) => keuze === OptInKeuze.Nee);
  const unknown = values.filter((keuze) => keuze === OptInKeuze.Onbekend);

  const isAllJa = ja.length === values.length;
  const isAllNee = nee.length === values.length;
  const isAllUnknown = unknown.length === values.length;
  const isIndeterminate = !isAllJa && !isAllNee && !isAllUnknown;

  return { isAllJa, isAllNee, isAllUnknown, isIndeterminate };
};

const mediumTotalStatuses = computed(() => {
  return media.reduce((statuses, medium) => {
    statuses[medium.key] = calculateStatus(
        listPermissie.value.map((permissie) => getMediumValue(permissie, medium.key))
    );
    return statuses;
  }, {} as Record<CommunicatieMedium, CheckboxStatus>);
});

const allTotalStatus = computed(() => {
  return calculateStatus(
      listPermissie.value.flatMap((permissie) =>
          media.map((medium) => getMediumValue(permissie, medium.key))
      )
  );
});

function getPermissie(permissie: string): PermissieViewModel {
  return get(props.groep, permissie) as PermissieViewModel;
}

function getMediumValue(
    permissie: string,
    medium: CommunicatieMedium
): OptInKeuze {
  return get(getPermissie(permissie), medium, OptInKeuze.Onbekend) as OptInKeuze;
}

function toggle(permissie: string, field: CommunicatieMedium): void {
  const waarde = get(get(props.groep, permissie), field, 0) === OptInKeuze.Ja
      ? OptInKeuze.Nee
      : OptInKeuze.Ja;
  onGroepChange(permissie, field, waarde);
}

function onToggle(arg1: { permissie: string; field: CommunicatieMedium }): void {
  toggle(arg1.permissie, arg1.field);
}

function setAll(medium: CommunicatieMedium, keuze: boolean): void {
  listPermissie.value.forEach((permissie) => {
    const waarde = keuze ? OptInKeuze.Ja : OptInKeuze.Nee;
    onGroepChange(permissie, medium, waarde);
  });
}

function setAllForRow(permissie: string, keuze: boolean): void {
  const waarde = keuze ? OptInKeuze.Ja : OptInKeuze.Nee;
  media.forEach((medium) => {
    onGroepChange(permissie, medium.key, waarde);
  });
}

function onToggleAll(arg1: { medium: CommunicatieMedium; value: boolean }): void {
  setAll(arg1.medium, arg1.value);
}

function onToggleRow(arg1: { permissie: string; value: boolean }): void {
  setAllForRow(arg1.permissie, arg1.value);
}

function onToggleEverything(arg1: { value: boolean }): void {
  listPermissie.value.forEach((permissie) => {
    setAllForRow(permissie, arg1.value);
  });
}

function onGroepChange(
    permissie: string,
    field: CommunicatieMedium,
    waarde: OptInKeuze
): void {
  emit("groepchange", {
    permissie,
    field,
    waarde,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.label), 1),
    _createVNode(VuePermissie, {
      label: _unref(t)('allTopics'),
      isTotal: true,
      onAllclick: onToggleAll,
      onAllrowclick: onToggleEverything,
      "medium-statuses": _unref(mediumTotalStatuses),
      "all-status": _unref(allTotalStatus)
    }, null, 8, ["label", "medium-statuses", "all-status"]),
    _createVNode(VuePermissie, {
      label: _unref(t)('optinAuto'),
      "permissie-key": "Auto",
      permissie: __props.groep.Auto,
      onClick: onToggle,
      onRowclick: onToggleRow
    }, null, 8, ["label", "permissie"]),
    _createVNode(VuePermissie, {
      label: _unref(t)('optinMerkModel'),
      "permissie-key": "MerkModel",
      permissie: __props.groep.MerkModel,
      onClick: onToggle,
      onRowclick: onToggleRow
    }, null, 8, ["label", "permissie"]),
    _createVNode(VuePermissie, {
      label: _unref(t)('optinBedrijfsrelevant'),
      "permissie-key": "Bedrijf",
      permissie: __props.groep.Bedrijf,
      onClick: onToggle,
      onRowclick: onToggleRow
    }, null, 8, ["label", "permissie"]),
    _createVNode(VuePermissie, {
      label: _unref(t)('optinOverigrelevant'),
      "permissie-key": "Overig",
      permissie: __props.groep.Overig,
      onClick: onToggle,
      onRowclick: onToggleRow
    }, null, 8, ["label", "permissie"]),
    _createVNode(VuePermissie, {
      label: _unref(t)('optinEnquete'),
      "permissie-key": "Enquetes",
      permissie: __props.groep.Enquetes,
      onClick: onToggle,
      onRowclick: onToggleRow
    }, null, 8, ["label", "permissie"]),
    _createVNode(NietBenaderen, {
      label: _unref(t)('nietAutomatischBenaderen'),
      nietBenaderen: __props.nietBenaderen,
      class: "niet-benaderen",
      onClick: _cache[0] || (_cache[0] = (newVal) => emit('nietBenaderenChange', newVal))
    }, null, 8, ["label", "nietBenaderen"])
  ]))
}
}

})